import LazyLoadImages from './lazyLoadImages';
import { serializeForm } from '../modules/functions';
import { scrollTo } from './functions';
import Selects from '../components/selects';
import BasketFunctions from './basketFunctions';

export default function formSubmissionOverride(formTarget, containerTarget, paginationElementClass, loadMoreElementClass, addBasketFunction) {

    window.addEventListener('popstate', event => {
        const { state } = event;
        if (state) {
            getContent(state, null, setFilteredContent, false);
        }
        else {
            getContent(window.location.href, null, setFilteredContent, false);
        }
    });
    /* Filter reset */
    let form = document.querySelector(formTarget);
    let resultsContainer = document.querySelector(containerTarget);

    function filtersInit() {
        form = document.querySelector(formTarget);
        Selects(); // Custom selects init
        if (form) {
            let reset = form.querySelector('button[type="reset"]');
            let topFilter = form.querySelector('.js-filter-top-field');
            let sortFilter = form.querySelector('.js-filter-sort-field');
            let filterTags = document.querySelectorAll('.js-colour-tag');

            form.addEventListener('submit', function (e) {
                e.preventDefault();
                applyFilters();
            });

            if (reset) {
                reset.addEventListener('click', function () {
                    resetFilters();
                    applyFilters();
                });
            }

            if(topFilter) {
                topFilter.addEventListener('change', () => {
                    resetFilters();
                    applyFilters();
                })
            }

            if (sortFilter) {
                sortFilter.addEventListener('change', () => {
                    applyFilters();
                })
            }

            if(filterTags.length) {
                filterTags.forEach(tag => {
                    tag.addEventListener('click', (e) => {
                        let tagId = e.currentTarget.dataset.tagId;
                        if(document.getElementById(tagId)) {
                            document.getElementById(tagId).removeAttribute('checked');
                            applyFilters();
                        }
                    });
                });
            }
        }

        /* Toggle filters */
        let filtersToggle = document.querySelector('.js-filter-toggle');
        let filtersListing = document.querySelector('.filters-listing');

        if (filtersToggle) {
            filtersToggle.addEventListener('click', function (e) {
                e.preventDefault();
                this.classList.toggle('filters-open');
                filtersListing.classList.toggle('filters-listing--show');
            });
            let urlParams = new URLSearchParams(window.location.search);
            let urlParamKeys = [];
            for (const key of urlParams.keys()) {
                if (key !== 'c' && key !== 'p' && key !== 'sort') urlParamKeys.push(key);
            }
            if(urlParamKeys.length) filtersToggle.click();
        }
    }

    filtersInit();

    function resetFilters() {
        var cbxs = form.querySelectorAll('input[type=checkbox]');
        for (var i = 0, len = cbxs.length; i < len; i++) {
            cbxs[i].checked = false;
        }
    }

    function applyFilters() {
        let formData = new FormData(form);
        let asString = new URLSearchParams(formData).toString();
        let url = form.action + "?" + asString;
        window.emitter.emit('applyFilters', asString);
        getContent(url, '', setFilteredContent, true);
    }

    if (paginationElementClass && (paginationElementClass.length > 0) && resultsContainer) {
        resultsContainer.addEventListener('click', function (e) {
            if (e.target) {
                if (e.target.tagName == "A" && (e.target.className.includes(paginationElementClass) || e.target.className.includes(paginationElementClass))) {
                    e.preventDefault();
                   
                    if (addBasketFunction) {
                        getContent(e.target.getAttribute("href"), '', setFilteredContent, true, BasketFunctions);
                       
                    }
                    else {
                        getContent(e.target.getAttribute("href"), '', setFilteredContent, true);
                    }
                }
                else if (e.target.parentNode.tagName == "A" && (e.target.parentNode.className.includes(paginationElementClass) || e.target.parentNode.className.includes(paginationElementClass))) {
                    e.preventDefault();
                    if (addBasketFunction) {
                        getContent(e.target.getAttribute("href"), '', setFilteredContent, true, BasketFunctions);

                    }
                    else {
                        getContent(e.target.getAttribute("href"), '', setFilteredContent, true);
                    }
                }
            }
        });
    }

    function loadMoreInit() {

        if (loadMoreElementClass != "") {

            let loadMoreElement = document.querySelector('.' + loadMoreElementClass);

            if (loadMoreElement) {

                loadMoreElement.addEventListener('click', function (e) {
                    if (e.target) {
                        if (e.target.tagName == "A" && e.target.classList.contains(loadMoreElementClass)) {
                            e.preventDefault();
                            getContent(e.target.getAttribute("href"), '', setLoadMoreContent, true);
                        }
                        else if (e.target.parentNode.tagName == "A" && e.target.parentNode.classList.contains(loadMoreElementClass)) {
                            e.preventDefault();
                            getContent(e.target.parentNode.getAttribute("href"), '', setLoadMoreContent,true);
                        }
                    }
                });
            }

        }
    }

    loadMoreInit();

    function setFilteredContent(content, disableScroll, rebindBasket) {

        resultsContainer.innerHTML = content;
        loadMoreInit();
        var header = document.getElementsByTagName('header');
        //if (!disableScroll) {
            scrollTo(resultsContainer.getBoundingClientRect().top + document.documentElement.scrollTop - 100)
        //}
        if (rebindBasket) {
            BasketFunctions();
        }
    }

    function setLoadMoreContent(content) {

        let loadMoreElement = document.querySelector('.' + loadMoreElementClass);
        //Remove current load more
        var currentPagination = resultsContainer.getElementsByTagName("nav");

        loadMoreElement.parentElement.remove()

        // while (currentPagination[0]) currentPagination[0].parentNode.removeChild(currentPagination[0])
        resultsContainer.innerHTML += content;
        loadMoreInit()
        //lazyLoadImages();

    }

    function getContent(url, data, callback, pushState, callback2) {

        if (url.length < 1) {
            return;
        }

        fetch(url,
            {
                method: 'GET',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
            })
            .then(
                response => response.text()
            )
            .then(
                html => callback(html)
            )
            .then(
                html => callback2()
            )
            .catch(
                error => console.log(error.message)
            )
            .finally(function () {
                if (data && data.length > 1) {
                    url = url + "?" + data;
                }
                if (pushState) {
                    window.history.pushState(url, "", url);
                }
                window.emitter.emit('rerenderReactSaveColorComponents');
                filtersInit();
                LazyLoadImages();

           });

    }
}
